import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { RightDoubleArrowIcon } from "../../utils/icon.utils";
import { arrayMap } from "../../utils/array.utils";
import Skeleton from "react-loading-skeleton";
import { getRandomNumber } from "../../utils/number.utils";

export default function PagePath({ title = "", subTitle = "", breadCrumbs = [], loading = false }) {
  const navigate = useNavigate();
  const onNavigate = (link) => {
    navigate(link);
  };

  if (loading) return <PagePathSkeleton />;

  return (
    <div className="row align-items-center flex-column-reverse flex-lg-row">
      <div className="col-lg-6">
        {title && <Title className="m-0">{title}</Title>}
        {subTitle && <SubTitle className="m-0">{subTitle}</SubTitle>}
      </div>
      <div className="col-lg-6">
        <PathWrapper className="d-flex flex-wrap align-items-center list-unstyled justify-content-end m-0">
          {arrayMap(breadCrumbs, (item, index) => {
            if (!item?.link) {
              return (
                <li key={index + 1} className="ms-2 active">
                  {item?.name ?? ""}
                </li>
              );
            }
            return (
              <li key={index + 1} className="d-flex align-items-center ms-2">
                {item?.link && (
                  <ActiveLink onClick={() => onNavigate(item?.link)}>{item?.name ?? ""}</ActiveLink>
                )}
                {!(breadCrumbs?.length - 1 === index) && (
                  <span className="ms-2">
                    <RightDoubleArrowIcon />
                  </span>
                )}
              </li>
            );
          })}
        </PathWrapper>
      </div>
    </div>
  );
}

// skeleton
export function PagePathSkeleton() {
  return (
    <div className="row align-items-center flex-column-reverse flex-lg-row">
      <div className="col-lg-6">
        <Title className="m-0">
          <Skeleton width={`${getRandomNumber(30, 60)}%`} />
        </Title>
        <SubTitle className="m-0">
          <Skeleton width={`${getRandomNumber(15, 40)}%`} />
        </SubTitle>
      </div>
      <div className="col-lg-6">
        <div className="text-end">
          <Skeleton width={`${getRandomNumber(15, 45)}%`} />
        </div>
      </div>
    </div>
  );
}

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
`;

const SubTitle = styled.h4`
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--main-title-color);
`;

const PathWrapper = styled.ul`
  li {
    font-size: 0.8rem;
    color: var(--primary-text-color);
  }

  li span {
    font-size: 0.9rem;
    color: var(--default-text-color);
  }

  li.active {
    color: var(--default-text-color);
    font-weight: 600;
  }
`;

const ActiveLink = styled.div`
  cursor: pointer;
`;
